//-------------------------------
//  共通のSwiperオプション
//-------------------------------
const baseOptions = {
    loop: true,
    slidesPerView: "auto",
    speed: 4000,
    autoplay: {
        delay: 0,
        disableOnInteraction: false,
    },
    allowTouchMove: false,
    grabCursor: false,
    preloadImages: false,
    lazy: true,
};

//-------------------------------
//  初期化関数
//-------------------------------
function initSwiper(selector, options = {}) {
    return new Swiper(selector, {
        ...baseOptions,
        ...options,
        autoplay: {
            ...baseOptions.autoplay,
            ...options.autoplay,
        },
    });
}

//-------------------------------
//  呼び出し
//-------------------------------
//上段
initSwiper(".c-slider__row--top", {});
//下段（逆方向再生）
initSwiper(".c-slider__row--bottom", {
    autoplay: {
        reverseDirection: true,
    },
});
